export interface Prediction {
  districtId: string;
  horizon: "2wk" | "1mo" | "3mo";
  horizonWeeks: number;
  predictedCases: number;
  confidenceLower: number;
  confidenceUpper: number;
  confidenceScore: number;
  growthRate: number;
  alertLevel: "High" | "Medium" | "Low";
  topFeatures: { feature: string; importance: number }[];
}

function generatePredictions() {
  const data: Prediction[] = [];
  const districtIds = [
    "D01", "D02", "D03", "D04", "D05", "D06", "D07", "D08", "D09",
    "D10", "D11", "D12", "D13", "D14", "D15", "D16", "D17", "D18", "D19", "D20",
  ];
  const baseRates: Record<string, number> = {
    D01: 85, D02: 92, D03: 78, D04: 120, D05: 65,
    D06: 110, D07: 88, D08: 70, D09: 55, D10: 72,
    D11: 125, D12: 60, D13: 95, D14: 90, D15: 50,
    D16: 45, D17: 58, D18: 40, D19: 105, D20: 68,
  };

  const horizons: ("2wk" | "1mo" | "3mo")[] = ["2wk", "1mo", "3mo"];
  const horizonWeeksMap = { "2wk": 2, "1mo": 4, "3mo": 12 };

  const allFeatures = [
    "Prev. Cases (8wk)",
    "Weekly Rainfall",
    "Avg Temperature",
    "Population Density",
    "Seasonality Index",
    "Lag Cases (4wk)",
    "Rainfall Anomaly",
    "Humidity Index",
  ];

  for (const dId of districtIds) {
    for (const h of horizons) {
      const weeks = horizonWeeksMap[h];
      const base = baseRates[dId];
      // Seasonally adjust: currently in rainy season, so predictions are higher
      const seasonFactor = 1.6;
      const predicted = Math.round(base * seasonFactor * (1 + Math.random() * 0.4));
      const growthRate = Math.round((Math.random() * 50 - 5) * 10) / 10;

      const alertLevel: "High" | "Medium" | "Low" =
        growthRate > 30 ? "High" : growthRate > 10 ? "Medium" : "Low";

      // Feature importance (shuffled per district/horizon)
      const features = [...allFeatures]
        .sort(() => Math.random() - 0.5)
        .slice(0, 5)
        .map((f) => ({ feature: f, importance: Math.round((0.3 + Math.random() * 0.7) * 100) / 100 }));
      features.sort((a, b) => b.importance - a.importance);

      data.push({
        districtId: dId,
        horizon: h,
        horizonWeeks: weeks,
        predictedCases: predicted,
        confidenceLower: Math.round(predicted * 0.75),
        confidenceUpper: Math.round(predicted * 1.35),
        confidenceScore: Math.round((0.82 + Math.random() * 0.15) * 100) / 100,
        growthRate,
        alertLevel,
        topFeatures: features,
      });
    }
  }

  return data;
}

export const predictions = generatePredictions();